<template>
  <div>
    <div class="campaign-images">
      <error v-if="errors" :errors="errors"></error>

      <div class="drop-down-lang">
        <p>{{ $t("edit_campaign.select_lang_image") }}</p>
        <b-dropdown
          variant="-sm bttn--blue"
          right
          :text="
            langImagesSelect === ''
              ? $t('edit_campaign.lang_image_default')
              : getFullLang(langImagesSelect)
          "
        >
          <b-dropdown-item @click="langImagesSelect = ''">
            {{ $t("edit_campaign.lang_image_default") }}
          </b-dropdown-item>
          <b-dropdown-item
            v-for="(lang, index) in langs"
            :key="index"
            @click="langImagesSelect = lang.short"
          >
            {{ lang.long }}
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <b-row>
        <b-col>
          {{ $t("edit_campaign.layout_video_description") }}
        </b-col>
      </b-row>
      <b-row class="campaign-video">
        <b-input-group>
          <template #prepend>
            <strong>{{ $t("edit_campaign.campaign_video") }}</strong>
          </template>
          <b-form-input
            type="text"
            :disabled="!hasAccess"
            v-model="campaign_video"
            class="form-control form-unit__input"
            :placeholder="$t('edit_campaign.campaign_video_placeholder')"
          >
          </b-form-input>
          <template #append>
            <button
              class="bttn bttn--sm bttn--blue"
              type="button"
              @click="loadVideo('video', campaign_video, campaignVideo)"
            >
              {{ $t("edit_campaign.save_link") }}
            </button>
          </template>
        </b-input-group>
      </b-row>
      <b-row class="campaign-video">
        <b-input-group>
          <template #prepend>
            <strong>{{ $t("edit_campaign.countdown_video", "Countdown video link:") }}</strong>
          </template>
          <b-form-input
            type="text"
            :disabled="!hasAccess"
            v-model="countdown_video"
            class="form-control form-unit__input"
            :placeholder="$t('edit_campaign.countdown_video_placeholder', 'Enter video link')"
          >
          </b-form-input>
          <template #append>
            <button
              class="bttn bttn--sm bttn--blue"
              type="button"
              @click="loadVideo('countdown_video', countdown_video, countdownVideo)"
            >
              {{ $t("edit_campaign.save_link") }}
            </button>
          </template>
        </b-input-group>
      </b-row>

      <div class="images-section">
        <h4 class="images-section__title">{{ $t("edit_campaign.count_down_image") }}</h4>

        <div class="images-preview">
          <div class="images-preview__sliders">
            <div class="item-slot item-slot--s-desktop">
              <slider-laptop
                tag="countdown_hero"
                :imageset="countDownImage"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                :uploadImmediately="uploadImmediately.countdown_hero"
                screen="t0"
              >
              </slider-laptop>
              <error-message ref="countdown_hero"></error-message>

              <div class="item-slot item-slot--c-desktop">
                <div class="upload-bar">
                  <input
                    id="countdown_hero"
                    type="file"
                    :disabled="!hasAccess"
                    accept=".png, .jpg, .jpeg, .gif"
                    @change="
                      processFile($event, 'countdown_hero', uploadImmediately.countdown_hero)
                    "
                  />
                  <label for="countdown_hero" class="upload-bar__label">
                    <svg
                      viewBox="0 0 46 39"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-499.000000, -381.000000)"
                          fill="#107598"
                        >
                          <g id="Group-13" transform="translate(400.000000, 335.000000)">
                            <g id="noun_Plus_1894414" transform="translate(99.000000, 46.000000)">
                              <path
                                d="M42.7142857,0 L3.28571429,0 C1.47106439,0 0,1.45502841 0,3.24989691 L0,29.2490722 C0,31.0439407 1.47106439,32.4989691 3.28571429,32.4989691 L17.2828571,32.4989691 C16.6955446,33.4498728 15.8332917,34.2046104 14.807619,34.665567 C13.8,35.2722144 12.8361905,35.8355299 12.6171429,36.832165 C12.5644467,37.5142715 12.8405443,38.180927 13.3619048,38.6304412 C13.5819253,38.8789153 13.9045347,39.0145296 14.2380952,38.9987629 L31.7619048,38.9987629 C32.0507949,38.9946929 32.3263571,38.8778822 32.5285714,38.6737732 C33.0711428,38.2193421 33.3569852,37.5327206 33.2952381,36.832165 C33.1638095,35.7921979 32.2,35.2288825 31.1047619,34.665567 C30.0790892,34.2046104 29.2168364,33.4498728 28.6295238,32.4989691 L42.7142857,32.4989691 C44.5289356,32.4989691 46,31.0439407 46,29.2490722 L46,3.24989691 C46,1.45502841 44.5289356,0 42.7142857,0 Z M43.8095238,25.9991753 L2.19047619,25.9991753 L2.19047619,3.24989691 C2.19047619,2.65160741 2.68083099,2.16659794 3.28571429,2.16659794 L42.7142857,2.16659794 C43.319169,2.16659794 43.8095238,2.65160741 43.8095238,3.24989691 L43.8095238,25.9991753 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M22.992074,8 C23.5944518,8 24.0700132,8.47556143 24.0700132,9.07793923 L24.0700132,12.9299868 L27.9220608,12.9299868 C28.5085865,12.9299868 29,13.4055482 29,13.992074 C29,14.5944518 28.5085865,15.0700132 27.9220608,15.0700132 L24.0700132,15.0700132 L24.0700132,18.9220608 C24.0700132,19.5085865 23.5944518,20 22.992074,20 C22.4055482,20 21.9299868,19.5085865 21.9299868,18.9220608 L21.9299868,15.0700132 L18.0779392,15.0700132 C17.4755614,15.0700132 17,14.5944518 17,13.992074 C17,13.4055482 17.4755614,12.9299868 18.0779392,12.9299868 L21.9299868,12.9299868 L21.9299868,9.07793923 C21.9299868,8.47556143 22.4055482,8 22.992074,8 Z"
                                id="Shape"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <span>{{ $t("edit_campaign.image_for_desktop") }}</span>
                  </label>
                </div>

                <uploadImmediatelyCbVue
                  class="mb-1"
                  id="countdown_hero"
                  v-model="uploadImmediately.countdown_hero"
                />

                <span class="img-cimages__size-text">
                  {{ $t("edit_campaign.image_for_desktop_sizes") }}
                </span>
              </div>
            </div>

            <div class="item-slot item-slot--s-mobile">
              <slider-mobile
                tag="countdown_hero_mobile"
                :imageset="countDownMobileImage"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                :uploadImmediately="uploadImmediately.countdown_hero_mobile"
                screen="m0"
              >
              </slider-mobile>
              <error-message ref="countdown_hero_mobile"></error-message>

              <div class="item-slot item-slot--c-mobile">
                <div class="upload-bar">
                  <input
                    id="countdown_hero_mobile"
                    type="file"
                    :disabled="!hasAccess"
                    @change="
                      processFile(
                        $event,
                        'countdown_hero_mobile',
                        uploadImmediately.countdown_hero_mobile
                      )
                    "
                  />
                  <label for="countdown_hero_mobile" class="upload-bar__label">
                    <svg
                      width="22px"
                      height="42px"
                      viewBox="0 0 22 42"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-517.000000, -636.000000)"
                          fill="#107598"
                        >
                          <g id="Group-16" transform="translate(401.000000, 591.000000)">
                            <g id="noun_Mobile_440898" transform="translate(116.000000, 45.000000)">
                              <path
                                d="M10.992074,14 C11.5944518,14 12.0700132,14.4755614 12.0700132,15.0779392 L12.0700132,18.9299868 L15.9220608,18.9299868 C16.5085865,18.9299868 17,19.4055482 17,19.992074 C17,20.5944518 16.5085865,21.0700132 15.9220608,21.0700132 L12.0700132,21.0700132 L12.0700132,24.9220608 C12.0700132,25.5085865 11.5944518,26 10.992074,26 C10.4055482,26 9.92998679,25.5085865 9.92998679,24.9220608 L9.92998679,21.0700132 L6.07793923,21.0700132 C5.47556143,21.0700132 5,20.5944518 5,19.992074 C5,19.4055482 5.47556143,18.9299868 6.07793923,18.9299868 L9.92998679,18.9299868 L9.92998679,15.0779392 C9.92998679,14.4755614 10.4055482,14 10.992074,14 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M21.9130435,39.2608696 L21.9130435,2.73913043 C21.9130435,1.2326087 20.6804348,0 19.173913,0 L2.73913043,0 C1.2326087,0 0,1.2326087 0,2.73913043 L0,39.2608696 C0,40.7673913 1.2326087,42 2.73913043,42 L19.173913,42 C20.6804348,42 21.9130435,40.7673913 21.9130435,39.2608696 Z M9.13043478,1.82608696 L12.7826087,1.82608696 L12.7826087,2.73913043 L9.13043478,2.73913043 L9.13043478,1.82608696 Z M10.9565217,40.173913 C9.95217391,40.173913 9.13043478,39.3521739 9.13043478,38.3478261 C9.13043478,37.3434783 9.95217391,36.5217391 10.9565217,36.5217391 C11.9608696,36.5217391 12.7826087,37.3434783 12.7826087,38.3478261 C12.7826087,39.3521739 11.9608696,40.173913 10.9565217,40.173913 Z M20.0869565,34.6956522 L1.82608696,34.6956522 L1.82608696,4.56521739 L20.0869565,4.56521739 L20.0869565,34.6956522 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <span>
                      {{ $t("edit_campaign.image_for_mobile") }}
                    </span>
                  </label>
                </div>

                <uploadImmediatelyCbVue
                  class="mb-1"
                  id="countdown_hero_mobile"
                  v-model="uploadImmediately.countdown_hero_mobile"
                />

                <span class="img-cimages__size-text">
                  {{ $t("edit_campaign.image_for_mobile_sizes") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STANDARD SECTION -->
      <div
        class="images-section"
        v-if="
          campaignTemplate === 'standard' ||
          campaignTemplate === 'standard2' ||
          campaignTemplate === 'standard-v2'
        "
      >
        <h4 class="images-section__title">{{ $t("edit_campaign.standart_template_image") }}</h4>

        <div class="images-preview">
          <div class="images-preview__sliders">
            <div class="item-slot item-slot--s-desktop">
              <slider-laptop
                tag="slider"
                :imageset="sliderImage"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                screen="t1"
                :uploadImmediately="uploadImmediately.standart_template_image"
              >
              </slider-laptop>

              <div class="item-slot item-slot--c-common">
                <error-message ref="slider"></error-message>
                <div class="upload-bar">
                  <input
                    type="file"
                    :disabled="!hasAccess"
                    name=""
                    id="s1"
                    @change="
                      processFile($event, 'slider', uploadImmediately.standart_template_image)
                    "
                  />
                  <label for="s1" class="upload-bar__label">
                    <svg
                      viewBox="0 0 46 39"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-499.000000, -381.000000)"
                          fill="#107598"
                        >
                          <g id="Group-13" transform="translate(400.000000, 335.000000)">
                            <g id="noun_Plus_1894414" transform="translate(99.000000, 46.000000)">
                              <path
                                d="M42.7142857,0 L3.28571429,0 C1.47106439,0 0,1.45502841 0,3.24989691 L0,29.2490722 C0,31.0439407 1.47106439,32.4989691 3.28571429,32.4989691 L17.2828571,32.4989691 C16.6955446,33.4498728 15.8332917,34.2046104 14.807619,34.665567 C13.8,35.2722144 12.8361905,35.8355299 12.6171429,36.832165 C12.5644467,37.5142715 12.8405443,38.180927 13.3619048,38.6304412 C13.5819253,38.8789153 13.9045347,39.0145296 14.2380952,38.9987629 L31.7619048,38.9987629 C32.0507949,38.9946929 32.3263571,38.8778822 32.5285714,38.6737732 C33.0711428,38.2193421 33.3569852,37.5327206 33.2952381,36.832165 C33.1638095,35.7921979 32.2,35.2288825 31.1047619,34.665567 C30.0790892,34.2046104 29.2168364,33.4498728 28.6295238,32.4989691 L42.7142857,32.4989691 C44.5289356,32.4989691 46,31.0439407 46,29.2490722 L46,3.24989691 C46,1.45502841 44.5289356,0 42.7142857,0 Z M43.8095238,25.9991753 L2.19047619,25.9991753 L2.19047619,3.24989691 C2.19047619,2.65160741 2.68083099,2.16659794 3.28571429,2.16659794 L42.7142857,2.16659794 C43.319169,2.16659794 43.8095238,2.65160741 43.8095238,3.24989691 L43.8095238,25.9991753 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M22.992074,8 C23.5944518,8 24.0700132,8.47556143 24.0700132,9.07793923 L24.0700132,12.9299868 L27.9220608,12.9299868 C28.5085865,12.9299868 29,13.4055482 29,13.992074 C29,14.5944518 28.5085865,15.0700132 27.9220608,15.0700132 L24.0700132,15.0700132 L24.0700132,18.9220608 C24.0700132,19.5085865 23.5944518,20 22.992074,20 C22.4055482,20 21.9299868,19.5085865 21.9299868,18.9220608 L21.9299868,15.0700132 L18.0779392,15.0700132 C17.4755614,15.0700132 17,14.5944518 17,13.992074 C17,13.4055482 17.4755614,12.9299868 18.0779392,12.9299868 L21.9299868,12.9299868 L21.9299868,9.07793923 C21.9299868,8.47556143 22.4055482,8 22.992074,8 Z"
                                id="Shape"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <svg
                      width="22px"
                      height="42px"
                      viewBox="0 0 22 42"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-517.000000, -636.000000)"
                          fill="#107598"
                        >
                          <g id="Group-16" transform="translate(401.000000, 591.000000)">
                            <g id="noun_Mobile_440898" transform="translate(116.000000, 45.000000)">
                              <path
                                d="M10.992074,14 C11.5944518,14 12.0700132,14.4755614 12.0700132,15.0779392 L12.0700132,18.9299868 L15.9220608,18.9299868 C16.5085865,18.9299868 17,19.4055482 17,19.992074 C17,20.5944518 16.5085865,21.0700132 15.9220608,21.0700132 L12.0700132,21.0700132 L12.0700132,24.9220608 C12.0700132,25.5085865 11.5944518,26 10.992074,26 C10.4055482,26 9.92998679,25.5085865 9.92998679,24.9220608 L9.92998679,21.0700132 L6.07793923,21.0700132 C5.47556143,21.0700132 5,20.5944518 5,19.992074 C5,19.4055482 5.47556143,18.9299868 6.07793923,18.9299868 L9.92998679,18.9299868 L9.92998679,15.0779392 C9.92998679,14.4755614 10.4055482,14 10.992074,14 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M21.9130435,39.2608696 L21.9130435,2.73913043 C21.9130435,1.2326087 20.6804348,0 19.173913,0 L2.73913043,0 C1.2326087,0 0,1.2326087 0,2.73913043 L0,39.2608696 C0,40.7673913 1.2326087,42 2.73913043,42 L19.173913,42 C20.6804348,42 21.9130435,40.7673913 21.9130435,39.2608696 Z M9.13043478,1.82608696 L12.7826087,1.82608696 L12.7826087,2.73913043 L9.13043478,2.73913043 L9.13043478,1.82608696 Z M10.9565217,40.173913 C9.95217391,40.173913 9.13043478,39.3521739 9.13043478,38.3478261 C9.13043478,37.3434783 9.95217391,36.5217391 10.9565217,36.5217391 C11.9608696,36.5217391 12.7826087,37.3434783 12.7826087,38.3478261 C12.7826087,39.3521739 11.9608696,40.173913 10.9565217,40.173913 Z M20.0869565,34.6956522 L1.82608696,34.6956522 L1.82608696,4.56521739 L20.0869565,4.56521739 L20.0869565,34.6956522 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <span class="mobile-desk">{{ $t("edit_campaign.upload_image_slider") }}</span>
                  </label>
                </div>

                <uploadImmediatelyCbVue
                  class="mb-1"
                  id="standart_template_image"
                  v-model="uploadImmediately.standart_template_image"
                />

                <span class="img-cimages__size-text">{{
                  $t("edit_campaign.image_for_desktop_mobile_sizes")
                }}</span>
              </div>
            </div>

            <div class="item-slot item-slot--s-mobile">
              <slider-mobile
                tag="slider"
                :imageset="sliderImage"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                screen="m0"
                :uploadImmediately="uploadImmediately.standart_mobile_image"
              >
              </slider-mobile>

              <div class="item-slot item-slot--c-common">
                <error-message ref="slider"></error-message>
                <div class="upload-bar">
                  <input
                    type="file"
                    :disabled="!hasAccess"
                    name=""
                    id="s1"
                    @change="processFile($event, 'slider', uploadImmediately.standart_mobile_image)"
                  />
                  <label for="s1" class="upload-bar__label">
                    <svg
                      viewBox="0 0 46 39"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-499.000000, -381.000000)"
                          fill="#107598"
                        >
                          <g id="Group-13" transform="translate(400.000000, 335.000000)">
                            <g id="noun_Plus_1894414" transform="translate(99.000000, 46.000000)">
                              <path
                                d="M42.7142857,0 L3.28571429,0 C1.47106439,0 0,1.45502841 0,3.24989691 L0,29.2490722 C0,31.0439407 1.47106439,32.4989691 3.28571429,32.4989691 L17.2828571,32.4989691 C16.6955446,33.4498728 15.8332917,34.2046104 14.807619,34.665567 C13.8,35.2722144 12.8361905,35.8355299 12.6171429,36.832165 C12.5644467,37.5142715 12.8405443,38.180927 13.3619048,38.6304412 C13.5819253,38.8789153 13.9045347,39.0145296 14.2380952,38.9987629 L31.7619048,38.9987629 C32.0507949,38.9946929 32.3263571,38.8778822 32.5285714,38.6737732 C33.0711428,38.2193421 33.3569852,37.5327206 33.2952381,36.832165 C33.1638095,35.7921979 32.2,35.2288825 31.1047619,34.665567 C30.0790892,34.2046104 29.2168364,33.4498728 28.6295238,32.4989691 L42.7142857,32.4989691 C44.5289356,32.4989691 46,31.0439407 46,29.2490722 L46,3.24989691 C46,1.45502841 44.5289356,0 42.7142857,0 Z M43.8095238,25.9991753 L2.19047619,25.9991753 L2.19047619,3.24989691 C2.19047619,2.65160741 2.68083099,2.16659794 3.28571429,2.16659794 L42.7142857,2.16659794 C43.319169,2.16659794 43.8095238,2.65160741 43.8095238,3.24989691 L43.8095238,25.9991753 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M22.992074,8 C23.5944518,8 24.0700132,8.47556143 24.0700132,9.07793923 L24.0700132,12.9299868 L27.9220608,12.9299868 C28.5085865,12.9299868 29,13.4055482 29,13.992074 C29,14.5944518 28.5085865,15.0700132 27.9220608,15.0700132 L24.0700132,15.0700132 L24.0700132,18.9220608 C24.0700132,19.5085865 23.5944518,20 22.992074,20 C22.4055482,20 21.9299868,19.5085865 21.9299868,18.9220608 L21.9299868,15.0700132 L18.0779392,15.0700132 C17.4755614,15.0700132 17,14.5944518 17,13.992074 C17,13.4055482 17.4755614,12.9299868 18.0779392,12.9299868 L21.9299868,12.9299868 L21.9299868,9.07793923 C21.9299868,8.47556143 22.4055482,8 22.992074,8 Z"
                                id="Shape"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <svg
                      width="22px"
                      height="42px"
                      viewBox="0 0 22 42"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-517.000000, -636.000000)"
                          fill="#107598"
                        >
                          <g id="Group-16" transform="translate(401.000000, 591.000000)">
                            <g id="noun_Mobile_440898" transform="translate(116.000000, 45.000000)">
                              <path
                                d="M10.992074,14 C11.5944518,14 12.0700132,14.4755614 12.0700132,15.0779392 L12.0700132,18.9299868 L15.9220608,18.9299868 C16.5085865,18.9299868 17,19.4055482 17,19.992074 C17,20.5944518 16.5085865,21.0700132 15.9220608,21.0700132 L12.0700132,21.0700132 L12.0700132,24.9220608 C12.0700132,25.5085865 11.5944518,26 10.992074,26 C10.4055482,26 9.92998679,25.5085865 9.92998679,24.9220608 L9.92998679,21.0700132 L6.07793923,21.0700132 C5.47556143,21.0700132 5,20.5944518 5,19.992074 C5,19.4055482 5.47556143,18.9299868 6.07793923,18.9299868 L9.92998679,18.9299868 L9.92998679,15.0779392 C9.92998679,14.4755614 10.4055482,14 10.992074,14 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M21.9130435,39.2608696 L21.9130435,2.73913043 C21.9130435,1.2326087 20.6804348,0 19.173913,0 L2.73913043,0 C1.2326087,0 0,1.2326087 0,2.73913043 L0,39.2608696 C0,40.7673913 1.2326087,42 2.73913043,42 L19.173913,42 C20.6804348,42 21.9130435,40.7673913 21.9130435,39.2608696 Z M9.13043478,1.82608696 L12.7826087,1.82608696 L12.7826087,2.73913043 L9.13043478,2.73913043 L9.13043478,1.82608696 Z M10.9565217,40.173913 C9.95217391,40.173913 9.13043478,39.3521739 9.13043478,38.3478261 C9.13043478,37.3434783 9.95217391,36.5217391 10.9565217,36.5217391 C11.9608696,36.5217391 12.7826087,37.3434783 12.7826087,38.3478261 C12.7826087,39.3521739 11.9608696,40.173913 10.9565217,40.173913 Z M20.0869565,34.6956522 L1.82608696,34.6956522 L1.82608696,4.56521739 L20.0869565,4.56521739 L20.0869565,34.6956522 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <uploadImmediatelyCbVue
                      class="mb-1"
                      id="standart_mobile_image"
                      v-model="uploadImmediately.standart_mobile_image"
                    />

                    <span class="mobile-desk">{{ $t("edit_campaign.upload_image_slider") }}</span>
                  </label>
                </div>

                <span class="img-cimages__size-text">{{
                  $t("edit_campaign.image_for_desktop_mobile_sizes")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- UNIDY SECTION -->
      <div
        class="images-section"
        v-if="
          campaignTemplate === 'unidy' ||
          campaignTemplate === 'unidy2' ||
          campaignTemplate === 'unidy-v2'
        "
      >
        <h4 class="images-section__title">{{ $t("edit_campaign.select_campaign_image") }}</h4>

        <div class="images-preview">
          <div class="images-preview__sliders">
            <div class="item-slot item-slot--s-desktop">
              <slider-laptop
                tag="slider"
                :imageset="heroImage"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                screen="t2"
                :uploadImmediately="uploadImmediately.unidy_image"
              >
              </slider-laptop>

              <div class="item-slot item-slot--c-desktop">
                <error-message ref="slider"></error-message>
                <div class="upload-bar">
                  <input
                    type="file"
                    :disabled="!hasAccess"
                    name=""
                    id="hero_image"
                    @change="
                      processFile($event, 'slider', uploadImmediately.unidy_image, {
                        text: '64/15',
                        value: 64 / 15,
                      })
                    "
                  />
                  <label for="hero_image" class="upload-bar__label">
                    <svg
                      viewBox="0 0 46 39"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-499.000000, -381.000000)"
                          fill="#107598"
                        >
                          <g id="Group-13" transform="translate(400.000000, 335.000000)">
                            <g id="noun_Plus_1894414" transform="translate(99.000000, 46.000000)">
                              <path
                                d="M42.7142857,0 L3.28571429,0 C1.47106439,0 0,1.45502841 0,3.24989691 L0,29.2490722 C0,31.0439407 1.47106439,32.4989691 3.28571429,32.4989691 L17.2828571,32.4989691 C16.6955446,33.4498728 15.8332917,34.2046104 14.807619,34.665567 C13.8,35.2722144 12.8361905,35.8355299 12.6171429,36.832165 C12.5644467,37.5142715 12.8405443,38.180927 13.3619048,38.6304412 C13.5819253,38.8789153 13.9045347,39.0145296 14.2380952,38.9987629 L31.7619048,38.9987629 C32.0507949,38.9946929 32.3263571,38.8778822 32.5285714,38.6737732 C33.0711428,38.2193421 33.3569852,37.5327206 33.2952381,36.832165 C33.1638095,35.7921979 32.2,35.2288825 31.1047619,34.665567 C30.0790892,34.2046104 29.2168364,33.4498728 28.6295238,32.4989691 L42.7142857,32.4989691 C44.5289356,32.4989691 46,31.0439407 46,29.2490722 L46,3.24989691 C46,1.45502841 44.5289356,0 42.7142857,0 Z M43.8095238,25.9991753 L2.19047619,25.9991753 L2.19047619,3.24989691 C2.19047619,2.65160741 2.68083099,2.16659794 3.28571429,2.16659794 L42.7142857,2.16659794 C43.319169,2.16659794 43.8095238,2.65160741 43.8095238,3.24989691 L43.8095238,25.9991753 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M22.992074,8 C23.5944518,8 24.0700132,8.47556143 24.0700132,9.07793923 L24.0700132,12.9299868 L27.9220608,12.9299868 C28.5085865,12.9299868 29,13.4055482 29,13.992074 C29,14.5944518 28.5085865,15.0700132 27.9220608,15.0700132 L24.0700132,15.0700132 L24.0700132,18.9220608 C24.0700132,19.5085865 23.5944518,20 22.992074,20 C22.4055482,20 21.9299868,19.5085865 21.9299868,18.9220608 L21.9299868,15.0700132 L18.0779392,15.0700132 C17.4755614,15.0700132 17,14.5944518 17,13.992074 C17,13.4055482 17.4755614,12.9299868 18.0779392,12.9299868 L21.9299868,12.9299868 L21.9299868,9.07793923 C21.9299868,8.47556143 22.4055482,8 22.992074,8 Z"
                                id="Shape"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <span>{{ $t("edit_campaign.image_for_desktop") }}</span>
                  </label>
                </div>

                <uploadImmediatelyCbVue
                  class="mb-1"
                  id="unidy_image"
                  v-model="uploadImmediately.unidy_image"
                />

                <span class="img-cimages__size-text">{{
                  $t("edit_campaign.image_for_desktop_sizes")
                }}</span>
              </div>
            </div>

            <div class="item-slot item-slot--s-mobile">
              <slider-mobile
                tag="campaign_hero_mobile"
                :imageset="heroMobile"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                screen="m0"
                :uploadImmediately="uploadImmediately.unidy_image_mobile"
              >
              </slider-mobile>

              <div class="item-slot item-slot--c-mobile">
                <div class="upload-bar">
                  <input
                    type="file"
                    :disabled="!hasAccess"
                    name=""
                    id="hero_mobile"
                    @change="
                      processFile(
                        $event,
                        'campaign_hero_mobile',
                        uploadImmediately.unidy_image_mobile
                      )
                    "
                  />
                  <label for="hero_mobile" class="upload-bar__label">
                    <svg
                      width="22px"
                      height="42px"
                      viewBox="0 0 22 42"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-517.000000, -636.000000)"
                          fill="#107598"
                        >
                          <g id="Group-16" transform="translate(401.000000, 591.000000)">
                            <g id="noun_Mobile_440898" transform="translate(116.000000, 45.000000)">
                              <path
                                d="M10.992074,14 C11.5944518,14 12.0700132,14.4755614 12.0700132,15.0779392 L12.0700132,18.9299868 L15.9220608,18.9299868 C16.5085865,18.9299868 17,19.4055482 17,19.992074 C17,20.5944518 16.5085865,21.0700132 15.9220608,21.0700132 L12.0700132,21.0700132 L12.0700132,24.9220608 C12.0700132,25.5085865 11.5944518,26 10.992074,26 C10.4055482,26 9.92998679,25.5085865 9.92998679,24.9220608 L9.92998679,21.0700132 L6.07793923,21.0700132 C5.47556143,21.0700132 5,20.5944518 5,19.992074 C5,19.4055482 5.47556143,18.9299868 6.07793923,18.9299868 L9.92998679,18.9299868 L9.92998679,15.0779392 C9.92998679,14.4755614 10.4055482,14 10.992074,14 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M21.9130435,39.2608696 L21.9130435,2.73913043 C21.9130435,1.2326087 20.6804348,0 19.173913,0 L2.73913043,0 C1.2326087,0 0,1.2326087 0,2.73913043 L0,39.2608696 C0,40.7673913 1.2326087,42 2.73913043,42 L19.173913,42 C20.6804348,42 21.9130435,40.7673913 21.9130435,39.2608696 Z M9.13043478,1.82608696 L12.7826087,1.82608696 L12.7826087,2.73913043 L9.13043478,2.73913043 L9.13043478,1.82608696 Z M10.9565217,40.173913 C9.95217391,40.173913 9.13043478,39.3521739 9.13043478,38.3478261 C9.13043478,37.3434783 9.95217391,36.5217391 10.9565217,36.5217391 C11.9608696,36.5217391 12.7826087,37.3434783 12.7826087,38.3478261 C12.7826087,39.3521739 11.9608696,40.173913 10.9565217,40.173913 Z M20.0869565,34.6956522 L1.82608696,34.6956522 L1.82608696,4.56521739 L20.0869565,4.56521739 L20.0869565,34.6956522 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <span>{{ $t("edit_campaign.image_for_mobile") }}</span>
                  </label>
                </div>

                <uploadImmediatelyCbVue
                  class="mb-1"
                  id="unidy_image_mobile"
                  v-model="uploadImmediately.unidy_image_mobile"
                />

                <span class="img-cimages__size-text">{{
                  $t("edit_campaign.image_for_mobile_sizes")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DINNER SPARKLE -->
      <div class="images-section" v-if="campaignTemplate === 'dinner-sparkle'">
        <h4 class="images-section__title">
          {{ $t("edit_campaign.dinner_sparkle_top_right_image") }}
        </h4>

        <div class="images-preview">
          <div class="images-preview__sliders">
            <div class="item-slot item-slot--s-desktop">
              <slider-laptop
                tag="dinner_top_right"
                screen="t3"
                only-one
                :imageset="dinnerTopRight"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
              >
              </slider-laptop>

              <div class="item-slot item-slot--c-common">
                <error-message ref="dinner_top_right"></error-message>
                <div v-if="dinnerTopRight == 0" class="upload-bar">
                  <input
                    id="dinner_top_right"
                    type="file"
                    :disabled="!hasAccess"
                    @change="processFile($event, 'dinner_top_right')"
                  />
                  <label for="dinner_top_right" class="upload-bar__label">
                    <svg
                      viewBox="0 0 46 39"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-499.000000, -381.000000)"
                          fill="#107598"
                        >
                          <g id="Group-13" transform="translate(400.000000, 335.000000)">
                            <g id="noun_Plus_1894414" transform="translate(99.000000, 46.000000)">
                              <path
                                d="M42.7142857,0 L3.28571429,0 C1.47106439,0 0,1.45502841 0,3.24989691 L0,29.2490722 C0,31.0439407 1.47106439,32.4989691 3.28571429,32.4989691 L17.2828571,32.4989691 C16.6955446,33.4498728 15.8332917,34.2046104 14.807619,34.665567 C13.8,35.2722144 12.8361905,35.8355299 12.6171429,36.832165 C12.5644467,37.5142715 12.8405443,38.180927 13.3619048,38.6304412 C13.5819253,38.8789153 13.9045347,39.0145296 14.2380952,38.9987629 L31.7619048,38.9987629 C32.0507949,38.9946929 32.3263571,38.8778822 32.5285714,38.6737732 C33.0711428,38.2193421 33.3569852,37.5327206 33.2952381,36.832165 C33.1638095,35.7921979 32.2,35.2288825 31.1047619,34.665567 C30.0790892,34.2046104 29.2168364,33.4498728 28.6295238,32.4989691 L42.7142857,32.4989691 C44.5289356,32.4989691 46,31.0439407 46,29.2490722 L46,3.24989691 C46,1.45502841 44.5289356,0 42.7142857,0 Z M43.8095238,25.9991753 L2.19047619,25.9991753 L2.19047619,3.24989691 C2.19047619,2.65160741 2.68083099,2.16659794 3.28571429,2.16659794 L42.7142857,2.16659794 C43.319169,2.16659794 43.8095238,2.65160741 43.8095238,3.24989691 L43.8095238,25.9991753 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M22.992074,8 C23.5944518,8 24.0700132,8.47556143 24.0700132,9.07793923 L24.0700132,12.9299868 L27.9220608,12.9299868 C28.5085865,12.9299868 29,13.4055482 29,13.992074 C29,14.5944518 28.5085865,15.0700132 27.9220608,15.0700132 L24.0700132,15.0700132 L24.0700132,18.9220608 C24.0700132,19.5085865 23.5944518,20 22.992074,20 C22.4055482,20 21.9299868,19.5085865 21.9299868,18.9220608 L21.9299868,15.0700132 L18.0779392,15.0700132 C17.4755614,15.0700132 17,14.5944518 17,13.992074 C17,13.4055482 17.4755614,12.9299868 18.0779392,12.9299868 L21.9299868,12.9299868 L21.9299868,9.07793923 C21.9299868,8.47556143 22.4055482,8 22.992074,8 Z"
                                id="Shape"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <svg
                      width="22px"
                      height="42px"
                      viewBox="0 0 22 42"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-517.000000, -636.000000)"
                          fill="#107598"
                        >
                          <g id="Group-16" transform="translate(401.000000, 591.000000)">
                            <g id="noun_Mobile_440898" transform="translate(116.000000, 45.000000)">
                              <path
                                d="M10.992074,14 C11.5944518,14 12.0700132,14.4755614 12.0700132,15.0779392 L12.0700132,18.9299868 L15.9220608,18.9299868 C16.5085865,18.9299868 17,19.4055482 17,19.992074 C17,20.5944518 16.5085865,21.0700132 15.9220608,21.0700132 L12.0700132,21.0700132 L12.0700132,24.9220608 C12.0700132,25.5085865 11.5944518,26 10.992074,26 C10.4055482,26 9.92998679,25.5085865 9.92998679,24.9220608 L9.92998679,21.0700132 L6.07793923,21.0700132 C5.47556143,21.0700132 5,20.5944518 5,19.992074 C5,19.4055482 5.47556143,18.9299868 6.07793923,18.9299868 L9.92998679,18.9299868 L9.92998679,15.0779392 C9.92998679,14.4755614 10.4055482,14 10.992074,14 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M21.9130435,39.2608696 L21.9130435,2.73913043 C21.9130435,1.2326087 20.6804348,0 19.173913,0 L2.73913043,0 C1.2326087,0 0,1.2326087 0,2.73913043 L0,39.2608696 C0,40.7673913 1.2326087,42 2.73913043,42 L19.173913,42 C20.6804348,42 21.9130435,40.7673913 21.9130435,39.2608696 Z M9.13043478,1.82608696 L12.7826087,1.82608696 L12.7826087,2.73913043 L9.13043478,2.73913043 L9.13043478,1.82608696 Z M10.9565217,40.173913 C9.95217391,40.173913 9.13043478,39.3521739 9.13043478,38.3478261 C9.13043478,37.3434783 9.95217391,36.5217391 10.9565217,36.5217391 C11.9608696,36.5217391 12.7826087,37.3434783 12.7826087,38.3478261 C12.7826087,39.3521739 11.9608696,40.173913 10.9565217,40.173913 Z M20.0869565,34.6956522 L1.82608696,34.6956522 L1.82608696,4.56521739 L20.0869565,4.56521739 L20.0869565,34.6956522 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <span class="mobile-desk">
                      {{ $t("edit_campaign.upload_image_shared") }}
                    </span>
                  </label>
                </div>
                <span class="img-cimages__size-text text-break">
                  {{ $t("edit_campaign.image_for_dinner_sparkle_top_right_sizes") }}
                </span>
              </div>
            </div>

            <div class="item-slot item-slot--s-mobile">
              <slider-mobile
                tag="dinner_top_right"
                screen="m0"
                only-one
                :imageset="dinnerTopRight"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
              >
              </slider-mobile>

              <div class="item-slot item-slot--c-common">
                <error-message ref="dinner_top_right"></error-message>
                <div v-if="dinnerTopRight == 0" class="upload-bar">
                  <input
                    id="dinner_top_right"
                    type="file"
                    :disabled="!hasAccess"
                    @change="processFile($event, 'dinner_top_right')"
                  />
                  <label for="dinner_top_right" class="upload-bar__label">
                    <svg
                      viewBox="0 0 46 39"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-499.000000, -381.000000)"
                          fill="#107598"
                        >
                          <g id="Group-13" transform="translate(400.000000, 335.000000)">
                            <g id="noun_Plus_1894414" transform="translate(99.000000, 46.000000)">
                              <path
                                d="M42.7142857,0 L3.28571429,0 C1.47106439,0 0,1.45502841 0,3.24989691 L0,29.2490722 C0,31.0439407 1.47106439,32.4989691 3.28571429,32.4989691 L17.2828571,32.4989691 C16.6955446,33.4498728 15.8332917,34.2046104 14.807619,34.665567 C13.8,35.2722144 12.8361905,35.8355299 12.6171429,36.832165 C12.5644467,37.5142715 12.8405443,38.180927 13.3619048,38.6304412 C13.5819253,38.8789153 13.9045347,39.0145296 14.2380952,38.9987629 L31.7619048,38.9987629 C32.0507949,38.9946929 32.3263571,38.8778822 32.5285714,38.6737732 C33.0711428,38.2193421 33.3569852,37.5327206 33.2952381,36.832165 C33.1638095,35.7921979 32.2,35.2288825 31.1047619,34.665567 C30.0790892,34.2046104 29.2168364,33.4498728 28.6295238,32.4989691 L42.7142857,32.4989691 C44.5289356,32.4989691 46,31.0439407 46,29.2490722 L46,3.24989691 C46,1.45502841 44.5289356,0 42.7142857,0 Z M43.8095238,25.9991753 L2.19047619,25.9991753 L2.19047619,3.24989691 C2.19047619,2.65160741 2.68083099,2.16659794 3.28571429,2.16659794 L42.7142857,2.16659794 C43.319169,2.16659794 43.8095238,2.65160741 43.8095238,3.24989691 L43.8095238,25.9991753 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M22.992074,8 C23.5944518,8 24.0700132,8.47556143 24.0700132,9.07793923 L24.0700132,12.9299868 L27.9220608,12.9299868 C28.5085865,12.9299868 29,13.4055482 29,13.992074 C29,14.5944518 28.5085865,15.0700132 27.9220608,15.0700132 L24.0700132,15.0700132 L24.0700132,18.9220608 C24.0700132,19.5085865 23.5944518,20 22.992074,20 C22.4055482,20 21.9299868,19.5085865 21.9299868,18.9220608 L21.9299868,15.0700132 L18.0779392,15.0700132 C17.4755614,15.0700132 17,14.5944518 17,13.992074 C17,13.4055482 17.4755614,12.9299868 18.0779392,12.9299868 L21.9299868,12.9299868 L21.9299868,9.07793923 C21.9299868,8.47556143 22.4055482,8 22.992074,8 Z"
                                id="Shape"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <svg
                      width="22px"
                      height="42px"
                      viewBox="0 0 22 42"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-517.000000, -636.000000)"
                          fill="#107598"
                        >
                          <g id="Group-16" transform="translate(401.000000, 591.000000)">
                            <g id="noun_Mobile_440898" transform="translate(116.000000, 45.000000)">
                              <path
                                d="M10.992074,14 C11.5944518,14 12.0700132,14.4755614 12.0700132,15.0779392 L12.0700132,18.9299868 L15.9220608,18.9299868 C16.5085865,18.9299868 17,19.4055482 17,19.992074 C17,20.5944518 16.5085865,21.0700132 15.9220608,21.0700132 L12.0700132,21.0700132 L12.0700132,24.9220608 C12.0700132,25.5085865 11.5944518,26 10.992074,26 C10.4055482,26 9.92998679,25.5085865 9.92998679,24.9220608 L9.92998679,21.0700132 L6.07793923,21.0700132 C5.47556143,21.0700132 5,20.5944518 5,19.992074 C5,19.4055482 5.47556143,18.9299868 6.07793923,18.9299868 L9.92998679,18.9299868 L9.92998679,15.0779392 C9.92998679,14.4755614 10.4055482,14 10.992074,14 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M21.9130435,39.2608696 L21.9130435,2.73913043 C21.9130435,1.2326087 20.6804348,0 19.173913,0 L2.73913043,0 C1.2326087,0 0,1.2326087 0,2.73913043 L0,39.2608696 C0,40.7673913 1.2326087,42 2.73913043,42 L19.173913,42 C20.6804348,42 21.9130435,40.7673913 21.9130435,39.2608696 Z M9.13043478,1.82608696 L12.7826087,1.82608696 L12.7826087,2.73913043 L9.13043478,2.73913043 L9.13043478,1.82608696 Z M10.9565217,40.173913 C9.95217391,40.173913 9.13043478,39.3521739 9.13043478,38.3478261 C9.13043478,37.3434783 9.95217391,36.5217391 10.9565217,36.5217391 C11.9608696,36.5217391 12.7826087,37.3434783 12.7826087,38.3478261 C12.7826087,39.3521739 11.9608696,40.173913 10.9565217,40.173913 Z M20.0869565,34.6956522 L1.82608696,34.6956522 L1.82608696,4.56521739 L20.0869565,4.56521739 L20.0869565,34.6956522 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <span class="mobile-desk">
                      {{ $t("edit_campaign.upload_image_shared") }}
                    </span>
                  </label>
                </div>
                <span class="img-cimages__size-text text-break">
                  {{ $t("edit_campaign.image_for_dinner_sparkle_top_right_sizes") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- SHARE -->
      <div class="images-section">
        <h4 class="images-section__title">{{ $t("edit_campaign.shared_image") }}</h4>

        <div class="images-preview">
          <div class="images-preview__sliders">
            <div class="item-slot item-slot--s-desktop">
              <slider-laptop
                tag="shared_image"
                :imageset="shareImage"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                screen="t3"
                :uploadImmediately="uploadImmediately.image_shared"
              >
              </slider-laptop>
            </div>
            <div class="item-slot item-slot--s-mobile">
              <slider-mobile
                tag="shared_image"
                :imageset="shareImage"
                @cUpdFile="changeFile"
                @cDelFile="removeFile"
                @cUplFile="processFile"
                screen="m1"
                :uploadImmediately="uploadImmediately.image_shared"
              >
              </slider-mobile>

              <div class="item-slot item-slot--c-common">
                <error-message ref="shared_image"></error-message>
                <div class="upload-bar">
                  <input
                    type="file"
                    :disabled="!hasAccess"
                    name=""
                    id="shared_image"
                    @change="processFile($event, 'shared_image', uploadImmediately.image_shared)"
                  />
                  <label for="shared_image" class="upload-bar__label">
                    <svg
                      viewBox="0 0 46 39"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-499.000000, -381.000000)"
                          fill="#107598"
                        >
                          <g id="Group-13" transform="translate(400.000000, 335.000000)">
                            <g id="noun_Plus_1894414" transform="translate(99.000000, 46.000000)">
                              <path
                                d="M42.7142857,0 L3.28571429,0 C1.47106439,0 0,1.45502841 0,3.24989691 L0,29.2490722 C0,31.0439407 1.47106439,32.4989691 3.28571429,32.4989691 L17.2828571,32.4989691 C16.6955446,33.4498728 15.8332917,34.2046104 14.807619,34.665567 C13.8,35.2722144 12.8361905,35.8355299 12.6171429,36.832165 C12.5644467,37.5142715 12.8405443,38.180927 13.3619048,38.6304412 C13.5819253,38.8789153 13.9045347,39.0145296 14.2380952,38.9987629 L31.7619048,38.9987629 C32.0507949,38.9946929 32.3263571,38.8778822 32.5285714,38.6737732 C33.0711428,38.2193421 33.3569852,37.5327206 33.2952381,36.832165 C33.1638095,35.7921979 32.2,35.2288825 31.1047619,34.665567 C30.0790892,34.2046104 29.2168364,33.4498728 28.6295238,32.4989691 L42.7142857,32.4989691 C44.5289356,32.4989691 46,31.0439407 46,29.2490722 L46,3.24989691 C46,1.45502841 44.5289356,0 42.7142857,0 Z M43.8095238,25.9991753 L2.19047619,25.9991753 L2.19047619,3.24989691 C2.19047619,2.65160741 2.68083099,2.16659794 3.28571429,2.16659794 L42.7142857,2.16659794 C43.319169,2.16659794 43.8095238,2.65160741 43.8095238,3.24989691 L43.8095238,25.9991753 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                              <path
                                d="M22.992074,8 C23.5944518,8 24.0700132,8.47556143 24.0700132,9.07793923 L24.0700132,12.9299868 L27.9220608,12.9299868 C28.5085865,12.9299868 29,13.4055482 29,13.992074 C29,14.5944518 28.5085865,15.0700132 27.9220608,15.0700132 L24.0700132,15.0700132 L24.0700132,18.9220608 C24.0700132,19.5085865 23.5944518,20 22.992074,20 C22.4055482,20 21.9299868,19.5085865 21.9299868,18.9220608 L21.9299868,15.0700132 L18.0779392,15.0700132 C17.4755614,15.0700132 17,14.5944518 17,13.992074 C17,13.4055482 17.4755614,12.9299868 18.0779392,12.9299868 L21.9299868,12.9299868 L21.9299868,9.07793923 C21.9299868,8.47556143 22.4055482,8 22.992074,8 Z"
                                id="Shape"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <svg
                      width="22px"
                      height="42px"
                      viewBox="0 0 22 42"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g
                          id="images_1"
                          transform="translate(-517.000000, -636.000000)"
                          fill="#107598"
                        >
                          <g id="Group-16" transform="translate(401.000000, 591.000000)">
                            <g id="noun_Mobile_440898" transform="translate(116.000000, 45.000000)">
                              <path
                                d="M10.992074,14 C11.5944518,14 12.0700132,14.4755614 12.0700132,15.0779392 L12.0700132,18.9299868 L15.9220608,18.9299868 C16.5085865,18.9299868 17,19.4055482 17,19.992074 C17,20.5944518 16.5085865,21.0700132 15.9220608,21.0700132 L12.0700132,21.0700132 L12.0700132,24.9220608 C12.0700132,25.5085865 11.5944518,26 10.992074,26 C10.4055482,26 9.92998679,25.5085865 9.92998679,24.9220608 L9.92998679,21.0700132 L6.07793923,21.0700132 C5.47556143,21.0700132 5,20.5944518 5,19.992074 C5,19.4055482 5.47556143,18.9299868 6.07793923,18.9299868 L9.92998679,18.9299868 L9.92998679,15.0779392 C9.92998679,14.4755614 10.4055482,14 10.992074,14 Z"
                                id="Shape"
                              ></path>
                              <path
                                d="M21.9130435,39.2608696 L21.9130435,2.73913043 C21.9130435,1.2326087 20.6804348,0 19.173913,0 L2.73913043,0 C1.2326087,0 0,1.2326087 0,2.73913043 L0,39.2608696 C0,40.7673913 1.2326087,42 2.73913043,42 L19.173913,42 C20.6804348,42 21.9130435,40.7673913 21.9130435,39.2608696 Z M9.13043478,1.82608696 L12.7826087,1.82608696 L12.7826087,2.73913043 L9.13043478,2.73913043 L9.13043478,1.82608696 Z M10.9565217,40.173913 C9.95217391,40.173913 9.13043478,39.3521739 9.13043478,38.3478261 C9.13043478,37.3434783 9.95217391,36.5217391 10.9565217,36.5217391 C11.9608696,36.5217391 12.7826087,37.3434783 12.7826087,38.3478261 C12.7826087,39.3521739 11.9608696,40.173913 10.9565217,40.173913 Z M20.0869565,34.6956522 L1.82608696,34.6956522 L1.82608696,4.56521739 L20.0869565,4.56521739 L20.0869565,34.6956522 Z"
                                id="Shape"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>

                    <span class="mobile-desk">{{ $t("edit_campaign.upload_image_shared") }}</span>
                  </label>
                </div>

                <uploadImmediatelyCbVue
                  class="mb-1"
                  id="image_shared_mobile"
                  v-model="uploadImmediately.image_shared"
                  :checked="uploadImmediately.image_shared"
                />

                <span class="img-cimages__size-text">{{
                  $t("edit_campaign.image_for_desktop_mobile_sizes")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-image" v-if="loadingImage">
      <img src="https://editionsdelarose.com/wp-content/themes/edr/img/loading.gif" />
    </div>

    <MediaStorageCropperModal :campaignTemplate="campaignTemplate" ref="MediaStorageCropperModal" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import axios from "axios";
import { filterWithFallback } from "@/helpers/filters.js";
import urls from "@/constants/urls.js";
import error from "@/components/errors.vue";
import ClickOutside from "vue-click-outside";
import sliderLaptop from "@/views/campaigns/campaign-images/sliderLaptopBig";
import sliderMobile from "@/views/campaigns/campaign-images/sliderMobileBig";
import errorList from "@/components/error-message.vue";

import MediaStorageCropperModal from "@/views/media-storage/MediaStorageCropperModal.vue";
import uploadImmediatelyCbVue from "./upload-immediately-cb.vue";

export default {
  props: {
    teamId: {
      type: Number,
      default: 0,
    },
    edit: Boolean,
  },

  data() {
    return {
      load: false,
      loadingImage: false,
      errors: [],
      selectedTemplate: null,
      langImagesSelect: "",
      campaign_video: "",
      countdown_video: "",
      tempSrc: "",
      tempTag: "",
      tempFile: null,
      uploadImmediately: {},
    };
  },

  components: {
    error: error,
    errorMessage: errorList,
    sliderLaptop: sliderLaptop,
    sliderMobile: sliderMobile,
    MediaStorageCropperModal,
    uploadImmediatelyCbVue,
  },

  mounted() {
    this.selectedTemplate = this.campaignTemplate;
    this.campaign_video = this.campaignVideo[0] ? this.campaignVideo[0].attributes.src : "";
    this.countdown_video = this.countdownVideo[0] ? this.countdownVideo[0].attributes.src : "";
  },

  computed: {
    ...mapState({
      campaignId: (state) => state.campaign.campaign.data.id,
      hasAccess: (state) => state.account.access.CanEditCampaignMedia,
      campaignTemplate: (state) => state.campaign.campaign.data.attributes.template,
      campaignTemplates: (state) => state.campaign.campaignTemplates,

      orgId() {
        return localStorage.getItem("orgId");
      },

      langs() {
        return this.getOldLangsVariant;
      },

      allMediaArr: (state) => {
        let relationships =
          (state.campaign && state.campaign.campaign.data.relationships.campaign_media.data) || [];

        let included = state.campaign.campaign.included;

        let arrMedia = [];

        for (let i = 0; i < relationships.length; i++) {
          let el = included.filter((el) => {
            return el.id == relationships[i].id && el.type == relationships[i].type;
          });

          arrMedia.push(el[0]);
        }

        return arrMedia;
      },

      sliderImage() {
        let allMedia = this.allMediaArr;

        const filterCommonPart = (el, tag = "slider") =>
          el.attributes.tag == tag && el.attributes.lang === this.langImagesSelect;

        let media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },

      heroImage() {
        let allMedia = this.allMediaArr;
        let media = [];

        const filterCommonPart = (el, tag = "slider") =>
          el.attributes.tag == tag && el.attributes.lang === this.langImagesSelect;

        media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        if (media.length > 0) {
          return media;
        }

        media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) =>
            filterCommonPart(el, "campaign_hero") && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },

      heroMobile() {
        let allMedia = this.allMediaArr;

        const filterCommonPart = (el) =>
          el.attributes.tag == "campaign_hero_mobile" &&
          el.attributes.lang === this.langImagesSelect;

        let media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },

      countDownImage() {
        let allMedia = this.allMediaArr;

        const filterCommonPart = (el) =>
          el.attributes.tag == "countdown_hero" && el.attributes.lang === this.langImagesSelect;

        let media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },

      countDownMobileImage() {
        let allMedia = this.allMediaArr;

        const filterCommonPart = (el) =>
          el.attributes.tag == "countdown_hero_mobile" &&
          el.attributes.lang === this.langImagesSelect;

        let media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },

      shareImage() {
        let allMedia = this.allMediaArr;

        const filterCommonPart = (el) =>
          el.attributes.tag == "shared_image" && el.attributes.lang === this.langImagesSelect;

        let media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },

      dinnerTopRight() {
        return this.allMediaArr.filter((el) => {
          return (
            el.attributes.tag == "dinner_top_right" && el.attributes.lang === this.langImagesSelect
          );
        });
      },

      campaignVideo() {
        let allMedia = this.allMediaArr;

        const filterCommonPart = (el) =>
          el.attributes.tag == "video" && el.attributes.lang === this.langImagesSelect;

        let media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },

      countdownVideo() {
        let allMedia = this.allMediaArr;

        const filterCommonPart = (el) =>
          el.attributes.tag == "countdown_video" && el.attributes.lang === this.langImagesSelect;

        let media = filterWithFallback({
          list: allMedia,
          filterFunc: (el) => filterCommonPart(el) && el.attributes.team_id === this.getTeamId(-1),
        });

        return media;
      },
    }),
    ...mapGetters({
      getOldLangsVariant: "getOldLangsVariant",
    }),
  },

  watch: {
    campaignVideo(newVal) {
      if (newVal.length) {
        this.campaign_video = newVal[0].attributes.src;
      } else {
        this.campaign_video = "";
      }
    },
    countdownVideo(newVal) {
      if (newVal.length) {
        this.countdown_video = newVal[0].attributes.src;
      } else {
        this.countdown_video = "";
      }
    },
  },

  methods: {
    ...mapActions({
      fetchDeleteMediaFile: "fetchDeleteMediaFile",
    }),

    getTeamId(defaultID = false) {
      if (defaultID && !this.teamId) {
        return defaultID;
      }
      return this.teamId;
    },

    getFullLang(short) {
      const langSenected = this.getOldLangsVariant.filter((el) => el.short === short);
      return langSenected.length > 0 ? langSenected[0].long : "Default";
    },

    processFile(fileInputEvent, tag, uploadImmediately, aspectRatio) {
      this.load = true;

      this.errors = [];

      let fileInput = fileInputEvent.target.files[0];

      if (fileInput != null) {
        if (fileInput.size > 2621440) {
          this.$refs[tag].setErrorResponse({
            data: {
              error_translation_key: "edit_campaign.upload_file_too_big_2_5mb",
              error: "File too big! Reduce the file size to 2.5MB or less.",
            },
          });
        } else if (uploadImmediately) {
          this.$nextTick(() => {
            this.$refs[tag] && this.$refs[tag].clearErrors();
            this.processFileCall(fileInputEvent, fileInput, tag);
          });
        } else {
          this.$refs.MediaStorageCropperModal.open({ file: fileInput, tag, aspectRatio });
          this.$refs.MediaStorageCropperModal.onOK((blob) => {
            this.processFileCall(fileInputEvent, blob, tag);
            this.$nextTick(() => {
              this.$refs[tag] && this.$refs[tag].clearErrors();
            });
          });
        }
      }
    },

    processFileCall(e, fileInput, tag) {
      this.loadingImage = true;

      if (this.$refs[tag]) {
        this.$refs[tag].clearErrors();
      }

      let form_data = new FormData();

      if (tag === "shared_image") {
        // Validate file type for shared_image - only accept JPEG, PNG, GIF as
        // allowed types by Facebook
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];

        if (!fileInput || !allowedTypes.includes(fileInput.type.toLowerCase())) {
          this.loadingImage = false;
          this.load = false;
          this.$refs[tag].setErrorResponse({
            data: {
              error_translation_key: "edit_campaign.invalid_file_type_shared_image",
              error: "Only JPEG, PNG, and GIF files are allowed for shared images.",
            },
          });
          return;
        }

        // Validate image dimensions - must be at least 200x200px as
        // required by Facebook for shared images
        const img = new Image();
        const imageValidationPromise = new Promise((resolve, reject) => {
          img.onload = () => {
            if (img.width < 200 || img.height < 200) {
              reject(new Error("Image dimensions too small"));
            } else {
              resolve();
            }
          };
          img.onerror = () => reject(new Error("Invalid image"));
        });

        img.src = URL.createObjectURL(fileInput);

        imageValidationPromise
          .then(() => {
            form_data.append("file", fileInput);
            URL.revokeObjectURL(img.src);
            this.uploadFile(form_data, tag, e);
          })
          .catch(() => {
            this.loadingImage = false;
            this.load = false;
            URL.revokeObjectURL(img.src);
            this.$refs[tag].setErrorResponse({
              data: {
                error_translation_key: "edit_campaign.image_too_small_shared_image",
                error: "Image dimensions are too small. Minimum size required is 200px x 200px.",
              },
            });
          });
      } else {
        form_data.append("file", fileInput);
        this.uploadFile(form_data, tag, e);
      }
    },

    uploadFile(form_data, tag, e) {
      axios
        .post(urls.loadImageQuill.replace(":OrgId", this.orgId), form_data)
        .then((response) => {
          this.load = false;

          this.createNewMediaFile(response.data.src, tag);

          e.target.type = "text";
          e.target.type = "file";
        })
        .catch((e) => {
          this.load = false;
          if (e.response.data) {
            if (e.response.data.error) {
              this.errors.push(e.response.data.error);
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          } else {
            this.errors.push(this.$t("template.error_default"));
          }
        });
    },

    createNewMediaFile(src, tagImage) {
      this.load = true;

      this.errors = [];

      let mediaFile = {
        data: {
          attributes: {
            campaign_id: parseInt(this.campaignId),
            src: src,
            tag: String(tagImage),
            order: 1,
            lang: this.langImagesSelect,
            team_id: this.teamId,
          },
        },
      };

      axios
        .post(
          urls.loadImage.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId),
          mediaFile
        )
        .then(() => {
          this.loadingImage = false;

          this.load = false;

          this.$_notificationsMixin_makeToastCompat({
            group: "Notification",
            title: this.$t("edit_campaign.success_add_image"),
          });

          let extend = "?extend=campaign_stats&extend=content&extend=media&extend=matchers";

          this.$store.dispatch("updateCampaign", extend);
        })
        .catch((e) => {
          this.load = false;
          if (e.response.data) {
            if (e.response.data.error) {
              this.errors.push(e.response.data.error);
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          } else {
            this.errors.push(this.$t("template.error_default"));
          }
        });
    },

    loadVideo(tag, model, originalData) {
      if (originalData.length && model.trim() === "") {
        let [video] = originalData;

        return this.deleteVideo(video.id);
      }

      if (originalData.length) {
        let [video] = originalData;
        video.attributes.src = model.startsWith("/") ? model.substr(1) : model;

        const vtID = video.attributes.team_id;
        if (vtID && vtID !== this.teamId) {
          video.attributes.src = this.teamId;
        }

        let mediaFile = {
          data: {
            attributes: video.attributes,
          },
        };

        this.loadEditFile(mediaFile, video.id);
      } else {
        this.addNewVideo(tag, model);
      }
    },

    async deleteVideo(id) {
      this.loading = true;

      try {
        await this.fetchDeleteMediaFile({
          id,
          cId: this.campaignId,
        });

        this.$_notificationsMixin_makeToast(
          "Success",
          this.$t("edit_campaign.success_delete_video", "Successfully removed video")
        );

        this.$store.dispatch(
          "updateCampaign",
          `?${["extend=campaign_stats", "extend=content", "extend=media", "extend=matchers"].join(
            "&"
          )}`
        );
      } finally {
        this.loading = false;
      }
    },

    addNewVideo(tag, model) {
      this.load = true;

      this.errors = [];

      let mediaFile = {
        data: {
          attributes: {
            campaign_id: parseInt(this.campaignId),
            tag,
            // src: this.campaign_video,
            src: model.startsWith("/") ? model.substr(1) : model,
            lang: this.langImagesSelect,
            team_id: this.teamId,
          },
        },
      };

      axios
        .post(
          urls.loadImage.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId),
          mediaFile
        )
        .then(() => {
          this.load = false;

          this.$_notificationsMixin_makeToastCompat({
            group: "Notification",
            title: this.$t("edit_campaign.success_add_video"),
          });

          let extend = `?${[
            "extend=campaign_stats",
            "extend=content",
            "extend=media",
            "extend=matchers",
          ].join("&")}`;

          this.$store.dispatch("updateCampaign", extend);
        })
        .catch((e) => {
          this.load = false;
          if (e.response.data) {
            if (e.response.data.error) {
              this.errors.push(e.response.data.error);
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          } else {
            this.errors.push(this.$t("template.error_default"));
          }
        });
    },

    removeFile(image) {
      this.load = true;

      this.errors = [];

      axios
        .delete(
          urls.loadImage.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId) +
            "/" +
            image.id
        )
        .then(() => {
          this.load = false;

          this.$_notificationsMixin_makeToastCompat({
            group: "Notification",
            title: this.$t("edit_campaign.success_delete_image"),
          });

          let extend = "?extend=campaign_stats&extend=content&extend=media&extend=matchers";

          this.$store.dispatch("updateCampaign", extend);
        })
        .catch((e) => {
          this.load = false;
          if (e.response.data) {
            if (e.response.data.error) {
              this.errors.push(e.response.data.error);
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          } else {
            this.errors.push(this.$t("template.error_default"));
          }
        });
    },

    changeFile(file, image) {
      this.load = true;

      this.errors = [];

      let imageData = {
        data: {
          attributes: image.attributes,
        },
      };
      if (file.size > 2621440) {
        this.$refs[imageData.data.attributes.tag].setErrorResponse({
          data: {
            error_translation_key: "edit_campaign.upload_file_too_big_2_5mb",
            error: "File too big! Reduce the file size to 2.5MB or less.",
          },
        });
      } else {
        this.$refs[imageData.data.attributes.tag].clearErrors();
        let form_data = new FormData();

        this.loadingImage = true;

        form_data.append("file", file);

        let orgId = localStorage.getItem("orgId");

        axios
          .post(urls.loadImageQuill.replace(":OrgId", orgId), form_data)
          .then((response) => {
            this.load = false;

            imageData.data.attributes.src = response.data.src;

            if (this.edit) {
              this.loadEditFile(imageData, image.id);
            } else {
              this.load = false;
            }
          })
          .catch((e) => {
            this.load = false;
            if (e.response.data) {
              if (e.response.data.error) {
                this.errors.push(e.response.data.error);
              } else {
                this.errors.push(this.$t("template.error_default"));
              }
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          });
      }
    },

    loadEditFile(data, id) {
      let mediaTag = data.data.attributes.tag;
      axios
        .put(
          urls.loadImage.replace(":orgId", this.orgId).replace(":campaignId", this.campaignId) +
            "/" +
            id,
          data
        )
        .then(() => {
          this.loadingImage = false;

          this.load = false;

          this.$_notificationsMixin_makeToastCompat({
            group: "Notification",
            title:
              mediaTag !== "video" || mediaTag !== "countdown_video"
                ? this.$t("edit_campaign.success_edit_image")
                : this.$t("edit_campaign.success_edit_video"),
          });

          let extend = "?extend=campaign_stats&extend=content&extend=media&extend=matchers";

          this.$store.dispatch("updateCampaign", extend);
        })
        .catch((e) => {
          this.load = false;
          if (e.response.data) {
            if (e.response.data.error) {
              this.errors.push(e.response.data.error);
            } else {
              this.errors.push(this.$t("template.error_default"));
            }
          } else {
            this.errors.push(this.$t("template.error_default"));
          }
        });
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_vars.scss";

::v-deep .input-group-prepend,
::v-deep .input-group-append {
  align-items: center;
  margin: 0px 1em;
}

.bttn-round {
  margin-right: 10px;
}

.inner-tabs {
  display: flex;
  margin-bottom: 40px;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid rgba(196, 196, 196, 0.5);
  @media only screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    align-items: initial;
    // flex-direction: row;
  }
  &__unit {
    width: 100%;
    max-width: 140px;
    padding: 0 25px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0;
    border: none; // 1px solid $bb-100;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.125;
    @media only screen and (min-width: 768px) {
      font-size: 16px;
      max-width: 260px;
    }
    &:not(:last-of-type) {
      margin-bottom: 0;
      @media only screen and (min-width: 768px) {
        margin-bottom: initial;
        margin-right: 0;
      }
    }
    &.active {
      color: initial;
      background-color: initial;
      position: relative;
      &:after {
        content: "";
        display: block;
        width: 100%;
        height: 3px;
        background-color: #107598;
        position: absolute;
        bottom: -2px;
      }
    }
  }
}

.he {
  .inner-tabs {
    &__unit {
      &:not(:last-of-type) {
        @media only screen and (min-width: 768px) {
          margin-right: initial;
          margin-left: 0;
        }
      }
    }
  }
}

.loading-image {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
  img {
    width: 150px;
  }
}

.img-cimages > label.img-cimages__label .desktop-mobile svg {
  margin-left: 5px;
  margin-right: 5px;
}

.load-image-input {
  display: none !important;
}

.inner-image {
  background-position: center center;
  background-size: cover;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  &__action {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 160px;
    .bttn-round {
      &:nth-of-type(2) {
        margin-right: 10px;
      }
      &:nth-of-type(1) {
        margin-right: auto;
      }
      &:nth-of-type(4) {
        margin-left: auto;
      }
    }
  }
}

.images-preview {
  &__sliders {
    display: flex;
    flex-wrap: wrap;
    .item-slot {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &--s-desktop,
      &--s-mobile {
        margin-bottom: 20px;
      }
      &--c-desktop {
        flex-direction: column;
        align-items: center;
        text-align: center;
        > span {
          width: 100%;
          max-width: 280px;
          font-size: 12px;
        }
      }
      &--c-mobile {
        flex-direction: column;
        align-items: center;
        text-align: center;
        > span {
          width: 100%;
          max-width: 280px;
          font-size: 12px;
        }
      }
      &--c-common {
        width: 100%;
        flex-direction: column;
        align-items: center;
        text-align: center;
        > span {
          width: 100%;
          max-width: 280px;
          font-size: 12px;
        }
      }
    }
    .item-slot--s-desktop {
      order: 0;
    }
    .item-slot--s-mobile {
      order: 2;
      @media only screen and (min-width: 992px) {
        order: initial;
      }
    }
    .item-slot--c-desktop {
      order: 1;
      margin-bottom: 15px;
      @media only screen and (min-width: 992px) {
        order: initial;
      }
    }
    .item-slot--c-mobile {
      order: 3;
      //marging-bottom: 15px;
      @media only screen and (min-width: 992px) {
        order: initial;
      }
    }
    .item-slot--c-common {
      order: 3;
      //marging-bottom: 15px;
      @media only screen and (min-width: 992px) {
        order: initial;
      }
    }
  }
}

.upload-bar {
  width: 100%;
  margin-bottom: 10px;
  max-width: 280px;
  height: 60px;
  display: flex;
  justify-content: center;
  border: 1px solid #bbbcc4;
  border-radius: 5px;
  background-color: #f5faff;
  position: relative;
  > input {
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }
  &__label {
    margin: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    svg {
      display: block;
      height: 24px;
      width: auto;
      margin-right: 10px;
    }
    span {
      width: 60%;
      text-transform: uppercase;
      line-height: 1.125;
    }
  }
}

.templates-section {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  position: relative;
  &__controls {
    padding: 40px 15px 0 15px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
.template-rb {
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}

.template {
  margin: 15px;
  min-height: 270px;
  //background-color: rgba(0,0,0,.2);
  border: 3px solid transparent;
  display: block;
  align-self: flex-start;
  cursor: pointer;
  position: relative;
  border-radius: 6px;
  width: 100%;
  @media only screen and (min-width: 568px) {
    width: 46%;
    margin: calc(8% / 2 / 2);
  }
  // @media only screen and (min-width: 992px) {
  //   width: 30%;
  //   margin: calc(10%/3/2);
  // }
  &:before {
    content: "";
    width: 100%;
    display: block;
    padding-top: 120%;
  }
  &:after {
    content: "";
    display: block;
    border-radius: 6px;
    border: 3px solid transparent;
    // background-color: rgba(255,255,255, .5);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    opacity: 1;
    transition: all 0.2s ease-in-out;
  }
  &:hover {
    .template__inner {
      transform: scale(1.1);
    }
    // &:after {
    //   background-color: rgba(255,255,255, 0);
    //   border: 3px solid $bb-50;
    // }
  }
  &__inner {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all 0.2s ease-in-out;
    > img {
      margin-bottom: 5px;
      display: block;
      width: 100%;
      height: auto;
    }
  }
  &__title {
    padding: 0 15px;
    text-align: center;
    font-family: $vito-bold;
    font-size: 18px;
    color: $bb-100;
    position: absolute;
    top: 5%;
    left: 5%;
  }
  &__description {
    width: 80%;
    height: 32px;
    overflow: hidden;
    // border: 1px solid red;
    // padding: 0 15px;
    // text-align: center;
    font-family: $vito-light;
    font-size: 14px;
    line-height: 1.1;
    color: $fd;
    position: absolute;
    top: 12%;
    left: 8.5%;
  }
  &.current {
    border-color: $bb-100;
    &:hover {
      .template__inner {
        transform: scale(1);
      }
    }
  }
  &.not-set {
    &:hover {
      .template__inner {
        transform: scale(1);
      }
    }
  }
}

.template--active {
  background-color: #ffffff;
  border-color: $bb-100;
  &:after {
    opacity: 0;
  }
  &.not-set {
    border-color: $lr-50;
  }
}

.template-preview {
  display: inline-flex;
  padding: 0;
  background: transparent !important;
  border: none !important;
  color: $bb-100;
  font-size: 14px;
  text-decoration: underline;
  position: absolute;
  top: 5.7%;
  right: 10%;
}
.color-section {
  margin-bottom: 40px;
  &__inner {
    display: flex;
  }
  &__unit {
    width: 300px;
  }
}
.picker-block {
  width: 225px;
  height: 36px;
  position: relative;
  border: 1px solid #333333;
  cursor: pointer;
  &.show {
    .picker {
      display: block;
    }
  }
}

.picker {
  display: none;
  position: absolute;
  top: 102%;
  left: 0;
  z-index: 2;
}

.drop-down-lang {
  margin-bottom: 40px;
  width: 100%;
  flex-direction: column;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  p {
    margin: 0;
  }
}

.campaign-video {
  margin: 15px 0px 15px 0px;
  label {
    font-family: "VitoExtended-Bold";
    margin-top: 6px;
  }
}
</style>
